import React from "react"

const ThemeContext = React.createContext<string | null>(null)

export default ThemeContext
